import i18n from '../../../i18n'

const dayInMs = 24 * 60 * 60 * 1000

const getDefaultLocale = () => {
  return window.document.querySelector('html').getAttribute('lang')
}

const groupBy = (items, predicate) =>
  items.reduce(
    (result, item) => ({
      ...result,
      [predicate(item)]: [...(result[predicate(item)] || []), item]
    }),
    {}
  )

const toStartOfDayTimestamp = dateString => new Date(dateString).setHours(0, 0, 0, 0) / 1000

const toTimestamp = dateString => new Date(dateString).getTime() / 1000

const toLocalDate = (date, locale, formattingOpts) => date.toLocaleDateString(locale, formattingOpts)

const formatDayForChat = (timestamp, options) => {
  const defaults = { todayAsHour: false, locale: getDefaultLocale() }
  const opts = { ...defaults, ...options }
  const formattingOpts = { timeZone: opts.timeZone }

  const date = new Date(timestamp * 1000)
  const localDate = toLocalDate(date, opts.locale, formattingOpts)
  const localToday = toLocalDate(new Date(), opts.locale, formattingOpts)
  const localYesterday = toLocalDate(new Date(new Date().getTime() - dayInMs), opts.locale, formattingOpts)
  const aWeekAgo = new Date(new Date().setHours(0, 0, 0, 0) - 6 * dayInMs)

  if (localDate === localYesterday) {
    return i18n.$gettext('Yesterday')
  } else if (localDate === localToday) {
    if (opts.todayAsHour) {
      return formatTimeForChat(timestamp, options)
    } else {
      return i18n.$gettext('Today')
    }
  } else if (date >= aWeekAgo && date < new Date()) {
    return date.toLocaleDateString(opts.locale, { weekday: 'long', ...formattingOpts })
  } else {
    if (opts.speakable) {
      // format more likely to be read as a date by a screen reader
      return date.toLocaleDateString(opts.locale, { year: 'numeric', month: 'long', day: 'numeric', ...formattingOpts })
    } else {
      // format as "DD.MM.YYYY"
      return date.toLocaleDateString('de', { year: 'numeric', month: '2-digit', day: '2-digit', ...formattingOpts })
    }
  }
}

const formatTimeForChat = (timestamp, options) => {
  const defaults = { locale: getDefaultLocale() }
  const opts = { ...defaults, ...options }
  const date = new Date(timestamp * 1000)

  return date.toLocaleTimeString(opts.locale, {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    timeZone: opts.timeZone
  })
}

function addEllipsis(left, right) {
  if (left.endsWith('…') || left.endsWith('...') || right.trim() === '') {
    return left
  } else {
    return left + '…'
  }
}

function trimText(text, maxLength) {
  text = text.trim()

  if (text.length <= maxLength) {
    return text
  } else {
    const wholeWordsUpToMaxLengthTotal = new RegExp(`^(.{0,${maxLength}})(\\s.*)$`, 'us')
    const firstWord = /^(\S*)(\s*.*)$/su

    const result = wholeWordsUpToMaxLengthTotal.exec(text)

    if (result && result[1] !== '') {
      return addEllipsis(result[1], result[2])
    } else {
      // the first word is longer than maxLength
      const result2 = firstWord.exec(text)
      return addEllipsis(result2[1].slice(0, maxLength), result2[1].slice(maxLength) + result2[2])
    }
  }
}

export { groupBy, toStartOfDayTimestamp, toTimestamp, formatDayForChat, formatTimeForChat, trimText }
